<script>
import CandelaComponent from '@/components/CandelaComponent'

export default {
  extends: CandelaComponent,
  name: 'StatsBar',
  props: {
    items: {type: Array, default: () => []}
  }
}
</script>

<template>
<div class='candela-component'>
  <div class='d-flex flex-wrap flex-grow-1'>
    <candela-stat-box v-for='(item, i) in items'
      v-bind='item' :key='`stat-box-${i}`'/>
  </div>
</div>
</template>
